import y from "./_isArrayLike.mjs";
var o = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function i(f, u, t) {
  return function(n, e, r) {
    if (y(r))
      return f(n, e, r);
    if (r == null)
      return e;
    if (typeof r["fantasy-land/reduce"] == "function")
      return u(n, e, r, "fantasy-land/reduce");
    if (r[o] != null)
      return t(n, e, r[o]());
    if (typeof r.next == "function")
      return t(n, e, r);
    if (typeof r.reduce == "function")
      return u(n, e, r, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
  };
}
export {
  i as default
};
